import NavBar from "../components/nav_bar";
import Notepad from "../components/notepad";
import t from "../locales";
import { useState } from "react";
import SystemMessage from "../components/system_message";
import { useNotepadStore, birthyearValue } from "../store/notepad";
import SaveInfoTooltip from "../components/save_info_tooltip";
import youDataIcon from "../assets/images/you_data.png";
import dangerIcon from "../assets/images/you_data/gevaarsdriehoek.svg";

export default function YouData() {
  const ACCOUNTS = [
    {
      title: t("youdata_website_1"),
      password: t("youdata_password_1"),
      passwordTooltipPart: `${t("secrets_birthday_value").replace(
        "/",
        "",
      )}${birthyearValue}`,
      tooltipName: "birthday",
    },
    {
      title: t("youdata_website_2"),
      password: t("youdata_password_2"),
    },
    {
      title: t("youdata_website_3"),
      password: "",
      passwordTooltipPart: t("secrets_phonenumber_value"),
      tooltipName: "phonenumber",
    },
    {
      title: t("youdata_website_4"),
      password: t("youdata_password_4"),
    },
  ];
  const INPUT_STATES = {
    INITIAL: 0,
    WRONG: 1,
    CORRECT: 2,
  };
  const [state, setState] = useState(INPUT_STATES.INITIAL);
  const accountsShown = state == INPUT_STATES.WRONG ? 0 : ACCOUNTS.length;
  const emailKnown = useNotepadStore((state) => state.secrets.email);
  return (
    <>
      <SystemMessage text={t("youdata_system_message")} />
      <div className="you-data">
        <NavBar icon={youDataIcon} />
        <div className="you-data__row">
          <p className="you-data__label">{t("youdata_search")}</p>
          <div className="you-data__input-container">
            {emailKnown ? (
              <select
                name="emailSelect"
                id="emailSelect"
                defaultValue=""
                className="you-data__input"
              >
                <option value="" disabled></option>
                <option value={t("secrets_email_value")}>
                  {t("secrets_email_value")}
                </option>
              </select>
            ) : (
              <input
                id="emailField"
                type="text"
                className="you-data__input"
                name="title"
                placeholder={t("youdata_input_placeholder")}
              />
            )}

            <button
              className="you-data__go-button"
              onClick={() => {
                const searchValue = document.getElementById(
                  emailKnown ? "emailSelect" : "emailField",
                ).value;
                setState(
                  searchValue === t("secrets_email_value")
                    ? INPUT_STATES.CORRECT
                    : INPUT_STATES.WRONG,
                );
              }}
            >
              {t("youdata_go")}
            </button>
          </div>
          <span className="you-data__found">
            {state != INPUT_STATES.INITIAL && (
              <span>
                {accountsShown} {t("youdata_accounts_found")}
              </span>
            )}
          </span>
        </div>
        {state === INPUT_STATES.CORRECT &&
          ACCOUNTS.map((account) => (
            <div className="you-data__row" key={account.title}>
              <div className="you-data__title">{account.title}</div>
              <div className="you-data__password">
                <img className="you-data__danger-icon" src={dangerIcon} />
                {account.password}
                {"tooltipName" in account && (
                  <SaveInfoTooltip name={account.tooltipName} dir="right">
                    {account.passwordTooltipPart}
                  </SaveInfoTooltip>
                )}
              </div>
            </div>
          ))}
        <Notepad />
      </div>
    </>
  );
}
